<template>

  <div>

    <b-modal @hidden="getList" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalSpotFolder"
             id="modal-enterprise-spot-folder"
             hide-footer
             :title="'Pavimentos: ' + modalSpotFolderName ">

      <EnterpriseSpotFolder :division-name="modalSpotFolderName" :enterprise-id="foreignKey"
                            :foreign-key="modalSpotFolderDivisionId"/>

    </b-modal>


    <t-dialog-duplicate dialog-id="modal-duplicate-division" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onDuplicated">


      <template #default="{status}">

        <t-input hide-label :status="status" v-model="formDuplicate.enterpriseId" hidden/>
        <t-input hide-label :status="status" v-model="formDuplicate.enterpriseDivisionId" hidden/>
        <t-input label="Nome da nova Divisão" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>
    </t-dialog-duplicate>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseDivisionId" :primary-key="form.enterpriseDivisionId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Divisões"
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onItemReadDefault"
                 @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.enterpriseDivisionId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="6">

            <b-row>

              <t-input cols="8"
                       v-model="form.name"
                       label="Divisão"
                       placeholder="Ex.: Bloco A"
                       :add-error="error.name"
                       required/>

              <t-input cols="4" v-model="form.note" label="Obs."/>

            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>

      </b-col>

      <template #item(buttonSpotFolder)="{item}">
        <t-button @click="openModalSpotFolder(item.enterpriseDivisionId, item.name)">Pavimentos
          ({{ item.qtySpotFolder }})
        </t-button>
      </template>


      <template #append-default-buttons="{item}">


        <b-button @click="openDialogDuplicate(item.enterpriseId, item.enterpriseDivisionId, item.name)"
                  class="opacity-6-hover"
                  v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                  title="Duplicar Divisão">
          <b-icon-files variant="primary"/>
        </b-button>

      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";
import EnterpriseSpotFolder from "@/views/modules/place/EnterpriseSpotFolder";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, TDialogDuplicate, EnterpriseSpotFolder},
  name: 'EnterpriseDivision',
  data() {
    return {
      path: "place/enterprise-division", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseDivisionId", keyDelete: "enterpriseDivisionId"},
        {key: "name", label: "Divisão", cols: "2"},
        {key: "buttonSpotFolder", label: "Pavimentos", cols: "2"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseDivisionId: 0,
        name: "",
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      modalSpotFolder: false,
      modalSpotFolderName: "",
      modalSpotFolderDivisionId: 0,
      formDuplicateShow: false,
      formDuplicate: {
        enterpriseId: 0,
        enterpriseDivisionId: 0,
        origin: "",
        changeName: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseDivisionId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogDuplicate(enterpriseId, enterpriseDivisionId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.enterpriseId = enterpriseId
      this.formDuplicate.enterpriseDivisionId = enterpriseDivisionId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = origin

      this.openDialogForm('modal-duplicate-division')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicada", "Nova divisão <b>" + item.name + "</b> duplicada com sucesso!", "success", "b-toaster-top-center", true)

      this.getList()
    },
    openModalSpotFolder(id, name) {

      this.modalSpotFolder = true
      this.modalSpotFolderName = name
      this.modalSpotFolderDivisionId = id

    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
